import React from 'react';
import classNames from 'classnames';
import type { SidebarMenuItemProps } from './Sidebar.types';

const SidebarItem: React.FC<SidebarMenuItemProps> = ({
  url,
  linkingMode,
  title,
}) => (
  <a href={url} className={classNames('sidebar__nav-link', linkingMode)}>
    {title}
  </a>
);

export default SidebarItem;
